module.exports = __webpack_public_path__ + "img/yandex.192dce5.png";